import { render, staticRenderFns } from "./Conversations.vue?vue&type=template&id=bb9ace6c&scoped=true&"
import script from "./Conversations.vue?vue&type=script&lang=js&"
export * from "./Conversations.vue?vue&type=script&lang=js&"
import style0 from "./Conversations.vue?vue&type=style&index=0&id=bb9ace6c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb9ace6c",
  null
  
)

export default component.exports